import { render, staticRenderFns } from "./SocialFeedFooter.vue?vue&type=template&id=63a75dfd&"
import script from "./SocialFeedFooter.vue?vue&type=script&lang=js&"
export * from "./SocialFeedFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports